// OR Seed Quiz — квиз-подбор семян: экраны интро → q1..q4 → email → результаты
// сменяются в одном окне, ответы маппятся в state движка подбора.
// Карточки отрендерены сервером (or-seed-quiz.liquid), тут показ/скрытие.
// Движок (FROST..matches) скопирован из or-seed-finder.js с двумя изменениями
// в matches(): space 'any' не гейтит по месту; indoor-культуры (микрозелень)
// проходят outdoor-гейт — их метаполе только 'Indoors', но растут и на патио.
// ponytail: выделить общий модуль при следующей правке движка.
(function () {
    'use strict';

    if (window.orSeedQuizInit) return;
    window.orSeedQuizInit = true;

    // ---------- движок: скопировано из or-seed-finder.js ----------

    // Средние даты заморозков по зонам USDA: [последний весенний, первый осенний].
    // Зона 6 сверена с утверждённым прототипом (Apr 18 / Oct 15). 10+ — без заморозков.
    var FROST = {
        3: ['May 30', 'Sep 8'],
        4: ['May 20', 'Sep 22'],
        5: ['May 5', 'Oct 5'],
        6: ['Apr 18', 'Oct 15'],
        7: ['Apr 5', 'Oct 25'],
        8: ['Mar 20', 'Nov 10'],
        9: ['Mar 1', 'Nov 25'],
        10: null,
        11: null
    };
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    function toDate(str) { // 'Apr 18' → Date текущего года
        var p = str.split(' ');
        return new Date(new Date().getFullYear(), MONTHS.indexOf(p[0]), parseInt(p[1], 10));
    }
    function addDays(d, n) {
        var r = new Date(d.getTime());
        r.setDate(r.getDate() + n);
        return r;
    }
    function fmt(d) { return MONTHS[d.getMonth()] + ' ' + d.getDate(); }
    function rollForward(d) { // прошедшая дата бесполезна для напоминания — переносим на следующий год
        // сравниваем с местной полуночью: в сам день посева дата ещё актуальна
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        if (d.getTime() < today.getTime()) d.setFullYear(d.getFullYear() + 1);
        return d;
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    // YYYY-MM-DD из локальных компонент: toISOString уводит на день назад восточнее UTC
    function isoDay(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }

    // Тайминг и сезонный чип карточки для выбранной зоны
    function timingFor(zone, ds) {
        var frost = FROST[zone];
        var gs = ds.gs || 'any';
        var isFlower = ds.goals.indexOf('flower') !== -1;
        var isPerennial = ds.life.indexOf('perennial') !== -1 && ds.life.indexOf('annual') === -1;

        if (gs === 'indoor') {
            return { html: '<strong>Grow indoors year-round.</strong> Harvest in 1 to 3 weeks.', chip: 'indoors', dot: 'indoor' };
        }
        if (!frost) {
            if (gs === 'cool') return { html: '<strong>Frost-free zone:</strong> sow in your cool season, fall through early spring.', chip: 'cool season', dot: 'cool' };
            return { html: '<strong>Frost-free zone:</strong> plant nearly year-round, avoid peak summer heat.', chip: gs === 'warm' ? 'warm season' : 'sow anytime', dot: 'warm' };
        }

        var lf = frost[0];
        var indoors = fmt(addDays(toDate(lf), -42));
        // Осенний посев холодных культур: ~8 недель до первого заморозка,
        // чтобы успели вырасти (за 10 дней до заморозка сеять поздно)
        var fallDate = addDays(toDate(frost[1]), -56);
        var fallSow = fmt(fallDate);

        if (isPerennial && isFlower) {
            return { html: '<strong>Sow after ' + lf + ',</strong> or in fall to bloom next year.', chip: 'perennial', dot: 'cool' };
        }
        if (isFlower) {
            return { html: '<strong>Sow after your last frost (~' + lf + '),</strong> once soil is warm.', chip: 'sow after frost', dot: 'cool' };
        }
        if (gs === 'warm') {
            return { html: '<strong>Start indoors ~' + indoors + '.</strong> Transplant after your last frost near ' + lf + '.', chip: 'warm season', dot: 'warm' };
        }
        if (gs === 'cool') {
            // Ближайшее к сегодня окно посева — первым
            var springNext = rollForward(toDate(lf));
            var fallNext = rollForward(new Date(fallDate.getTime()));
            if (fallNext < springNext) {
                return { html: '<strong>Sow ~' + fallSow + ' for a fall harvest.</strong> In spring: direct-sow around ' + lf + '.', chip: 'cool season', dot: 'cool' };
            }
            return { html: '<strong>Direct-sow around ' + lf + '.</strong> Sow again ~' + fallSow + ' for fall.', chip: 'cool season', dot: 'cool' };
        }
        return { html: '<strong>Cool crops:</strong> sow near ' + lf + '. <strong>Warm crops:</strong> start indoors ~' + indoors + '.', chip: 'sow after frost', dot: 'mixed' };
    }

    // Даты-действия для напоминаний (прошедшие переносятся на следующий год).
    // Ветки зеркалят timingFor: indoor → цветы → warm/cool/any, иначе письмо
    // противоречит тексту карточки.
    function actionDates(zone, ds) {
        var frost = FROST[zone];
        if (ds.gs === 'indoor') return [];
        var out = [];
        if (!frost) {
            // Безморозная зона: холодным культурам — старт прохладного сезона (~Oct 1)
            if (ds.gs === 'cool' || ds.gs === 'any') {
                out.push({ label: 'Cool-season sowing: ' + ds.title, date: rollForward(new Date(new Date().getFullYear(), 9, 1)) });
            }
            return out;
        }
        var lf = toDate(frost[0]);
        if (ds.goals.indexOf('flower') !== -1) {
            out.push({ label: 'Sow ' + ds.title, date: rollForward(new Date(lf.getTime())) });
        } else if (ds.gs === 'warm') {
            out.push({ label: 'Start ' + ds.title + ' indoors', date: rollForward(addDays(lf, -42)) });
        } else if (ds.gs === 'cool') {
            out.push({ label: 'Direct-sow ' + ds.title, date: rollForward(new Date(lf.getTime())) });
            out.push({ label: 'Fall sowing: ' + ds.title, date: rollForward(addDays(toDate(frost[1]), -56)) });
        } else {
            out.push({ label: 'Sow cool crops: ' + ds.title, date: rollForward(new Date(lf.getTime())) });
            out.push({ label: 'Start warm crops indoors: ' + ds.title, date: rollForward(addDays(lf, -42)) });
        }
        return out;
    }

    // Сколько дней до ближайшего действия по этому паку (null = действий нет)
    function daysUntilAction(zone, ds) {
        var dates = actionDates(zone, ds);
        if (!dates.length) return null;
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        var min = Infinity;
        dates.forEach(function (a) {
            var d = Math.round((a.date.getTime() - today.getTime()) / 86400000);
            if (d >= 0 && d < min) min = d;
        });
        return min === Infinity ? null : min;
    }

    // Релевантность именно этому садовнику: сеять скоро > комфортная зона > рейтинг
    function scoreFor(state, ds) {
        var s = 0;
        if (ds.gs === 'indoor') {
            s += 3; // микрозелень сеют когда угодно, значит и сейчас
        } else {
            var days = daysUntilAction(state.zone, ds);
            if (days !== null) {
                if (days <= 30) s += 3;
                else if (days <= 60) s += 1.5;
            }
        }
        // зона в середине диапазона = культуре комфортно, а не на грани выживания
        if (ds.zones) {
            var zs = ds.zones.split(',').map(function (z) { return parseInt(z, 10); })
                .filter(function (z) { return z; });
            if (zs.length) {
                var lo = Math.min.apply(null, zs), hi = Math.max.apply(null, zs);
                if (state.zone > lo && state.zone < hi) s += 1;
            }
        }
        s += (ds.rating / 5) * 2;
        if (ds.rcount > 100) s += 0.5;
        if (ds.beginner) s += 0.5;
        return s;
    }

    function cardData(card) {
        var d = card.dataset;
        return {
            zones: d.zones || '',
            sun: d.sun || '',
            space: d.space || '',
            gs: d.gs || 'any',
            life: d.life || '',
            goals: d.goals || '',
            beginner: d.beginner === '1',
            rating: parseFloat(d.rating) || 0,
            rcount: parseInt(d.rcount, 10) || 0,
            title: d.title || '',
            url: d.url || '',
            isSet: d.set === '1',
            price: parseFloat(d.price) || 0,
            varieties: parseInt(d.varieties, 10) || 0
        };
    }

    // Чипы целей упрощены: veg вбирает салаты и фрукты/бахчевые
    var GOAL_ALIAS = { veg: ['veg', 'salad', 'fruit'], herb: ['herb'], micro: ['micro'], flower: ['flower'] };

    function matches(state, ds) {
        // Зона: пустой список зон = растёт везде.
        // Выбран Indoors = зона не важна вовсе (дома климат одинаковый: травы,
        // микрозелень, cat grass растут в любой зоне).
        // В безморозных зонах (10+) hardiness-списки (кураторские до 10b) гейтят только
        // многолетники: однолетники растут там в свой прохладный сезон.
        if (ds.zones && state.space !== 'indoor') {
            var perennial = ds.life.indexOf('perennial') !== -1 && ds.life.indexOf('annual') === -1;
            if (FROST[state.zone] !== null || perennial) {
                var ok = ds.zones.split(',').some(function (z) { return parseInt(z, 10) === state.zone; });
                if (!ok) return false;
            }
        }
        // Свет
        if (state.light === 'sun') {
            if (ds.sun && ds.sun.indexOf('full') === -1) return false;
        } else if (state.light === 'part') {
            if (ds.sun && ds.sun.indexOf('part') === -1) return false;
        } else { // low / indoor: тенеустойчивость ИЛИ растёт дома; пустой sun не ограничивает
            var lowOk = !ds.sun || ds.sun.indexOf('shade') !== -1 ||
                ds.gs === 'indoor' || ds.space.indexOf('indoor') !== -1;
            if (!lowOk) return false;
        }
        // Место: Outdoors / Indoors.
        // ИЗМЕНЕНИЕ против or-seed-finder.js: 'any' (ответ квиза «Indoors & Outdoors»)
        // не ограничивает по месту вовсе.
        if (state.space === 'any') {
            // место подходит любое
        } else if (state.space === 'outdoor') {
            // ИЗМЕНЕНИЕ против or-seed-finder.js: indoor-культуры пропускаем —
            // у всей микрозелени метаполе только 'Indoors', но она растёт и на
            // патио/подоконнике; иначе micro+outdoor давал бы пустую выдачу
            if (ds.gs !== 'indoor' && ds.space && ds.space.indexOf('outdoor') === -1) return false;
        } else {
            if (ds.gs !== 'indoor' && ds.space.indexOf('indoor') === -1) return false;
        }
        // Цели: ничего не выбрано = всё подходит
        if (state.goals.length) {
            var hit = state.goals.some(function (g) {
                return (GOAL_ALIAS[g] || [g]).some(function (a) { return ds.goals.indexOf(a) !== -1; });
            });
            if (!hit) return false;
        }
        if (state.beginner && !ds.beginner) return false;
        return true;
    }

    // ---------- конец копии движка ----------

    function initSection(root) {
        if (root.dataset.sqReady) return;
        root.dataset.sqReady = '1';

        var grid = root.querySelector('[data-sf-grid]');
        var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sf-card]'));
        // Пустой пул (мерчант выбрал пустую коллекцию) — не выходим: навигация
        // по экранам всё равно нужна, apply() покажет empty state вместо
        // мёртвой кнопки Get Started
        if (!grid) return;

        var setsGrid = root.querySelector('[data-sf-grid-sets]');
        var setsHead = root.querySelector('[data-sf-sets-head]');
        var setsSub = root.querySelector('[data-sf-sets-sub]');
        var singlesHead = root.querySelector('[data-sf-singles-head]');
        var resultsTitle = root.querySelector('[data-sf-results-title]');
        var totalEl = root.querySelector('[data-sf-total]');
        var countEl = root.querySelector('[data-sf-count]');
        var zoneLabel = root.querySelector('[data-sf-zone-label]');
        var frostEl = root.querySelector('[data-sf-frost]');
        var emptyEl = root.querySelector('[data-sf-empty]');
        var moreBtn = root.querySelector('[data-sf-more]');
        var expanded = false;

        // Один раз сортируем по рейтингу и раскладываем: сеты в свою сетку, остальное в основную
        cards.sort(function (a, b) {
            var da = cardData(a), db = cardData(b);
            return (db.rating - da.rating) || (db.rcount - da.rcount);
        });
        cards.forEach(function (c) {
            (c.dataset.set === '1' ? setsGrid : grid).appendChild(c);
        });
        totalEl.textContent = cards.length;

        // --- ответы квиза → state движка ---
        var answers = { goal: null, space: null, experience: null, winters: null };
        var state = {
            zone: parseInt(root.dataset.defaultZone, 10) || 6,
            light: 'sun',
            space: 'outdoor',
            goals: [],
            beginner: false
        };

        function buildState() {
            state.goals = answers.goal ? [answers.goal] : [];
            if (answers.space === 'indoor') {
                state.space = 'indoor';
                state.light = 'low';
            } else if (answers.space === 'both') {
                state.space = 'any'; // не ограничивать по месту (см. matches)
                state.light = 'sun';
            } else { // outdoor и pots: горшки у нас тоже "outdoor" по метаполю
                state.space = 'outdoor';
                state.light = 'sun';
            }
            state.beginner = answers.experience === 'new';
            var zoneByWinter = { north: 4, middle: 6, south: 9 };
            state.zone = zoneByWinter[answers.winters] || parseInt(root.dataset.defaultZone, 10) || 6;
        }

        // --- результаты: адаптированный apply() из finder, one-shot на входе ---
        var visible = [];

        function apply() {
            visible = [];
            cards.forEach(function (card) {
                var ds = cardData(card);
                var show = matches(state, ds);
                card.hidden = !show;
                if (!show) return;
                visible.push(card);
                var t = timingFor(state.zone, ds);
                card.querySelector('[data-sf-timing]').innerHTML = t.html;
                card.querySelector('[data-sf-chip]').textContent = t.chip;
                card.querySelector('.or-sf-card__dot').setAttribute('data-dot', t.dot);

                // Скоринг под конкретного садовника + метка «сеять пора сейчас»
                card.dataset.score = scoreFor(state, ds);
                var days = ds.gs === 'indoor' ? 0 : daysUntilAction(state.zone, ds);
                card.querySelector('[data-sf-now]').hidden = !(days !== null && days <= 30);
            });

            // Лучшие совпадения первыми (скор → рейтинг)
            visible.sort(function (a, b) {
                return (parseFloat(b.dataset.score) - parseFloat(a.dataset.score)) ||
                    (cardData(b).rating - cardData(a).rating);
            });
            visible.forEach(function (c) {
                (c.dataset.set === '1' ? setsGrid : grid).appendChild(c);
            });
            // Группы: сеты сверху, индивидуальные пакеты ниже
            var setsVisible = visible.filter(function (c) { return c.dataset.set === '1'; });
            var singles = visible.filter(function (c) { return c.dataset.set !== '1'; });

            setsHead.hidden = setsVisible.length === 0;
            singlesHead.hidden = singles.length === 0;

            // «от $X за сорт» по самому выгодному видимому сету
            var perVariety = Infinity;
            setsVisible.forEach(function (c) {
                var ds2 = cardData(c);
                if (ds2.varieties > 0 && ds2.price > 0) {
                    perVariety = Math.min(perVariety, ds2.price / ds2.varieties);
                }
            });
            if (!setsSub.dataset.fallback) setsSub.dataset.fallback = setsSub.textContent;
            if (perVariety < Infinity && setsSub.dataset.template) {
                setsSub.textContent = setsSub.dataset.template
                    .replace('{price}', '$' + perVariety.toFixed(2));
            } else {
                setsSub.textContent = setsSub.dataset.fallback;
            }

            // Подбор = короткий список лучших, остальное по кнопке
            var setsCap = expanded ? Infinity : 4;
            var singlesCap = expanded ? Infinity : 12;
            setsVisible.forEach(function (card, i) { if (i >= setsCap) card.hidden = true; });
            singles.forEach(function (card, i) { if (i >= singlesCap) card.hidden = true; });

            var hiddenCount = Math.max(0, setsVisible.length - setsCap) +
                Math.max(0, singles.length - singlesCap);
            moreBtn.hidden = hiddenCount === 0;
            if (hiddenCount) moreBtn.textContent = 'Show ' + hiddenCount + ' more matches';

            var shown = Math.min(setsVisible.length, setsCap) + Math.min(singles.length, singlesCap);
            resultsTitle.textContent = visible.length === 0
                ? 'Your matches'
                : (hiddenCount ? 'Top ' + shown + ' picks for Zone ' + state.zone
                               : shown + ' picks for your Zone ' + state.zone + ' garden');

            countEl.textContent = visible.length;
            zoneLabel.textContent = 'Zone ' + state.zone;
            frostEl.textContent = FROST[state.zone] ? '~' + FROST[state.zone][0] : 'Frost-free';
            emptyEl.hidden = visible.length > 0;
        }

        moreBtn.addEventListener('click', function () {
            expanded = true;
            apply();
        });

        // --- навигация по экранам ---
        var ORDER = ['intro', 'q1', 'q2', 'q3', 'q4', 'email', 'results'];
        var screens = Array.prototype.slice.call(root.querySelectorAll('[data-sq-screen]'));
        var advTimer;

        function goTo(name) {
            clearTimeout(advTimer); // отложенный автопереход не должен пережить ручной
            screens.forEach(function (s) { s.hidden = s.dataset.sqScreen !== name; });
            // на результатах панель пуста (все её экраны скрыты) — прячем рамку целиком
            root.querySelector('.or-sq__panel').hidden = name === 'results';
            if (name === 'results') {
                buildState();
                expanded = false;
                apply();
            }
            // без smooth: у старого Safari smooth-scrollIntoView глючит
            if (root.getBoundingClientRect().top < 0) root.scrollIntoView({ block: 'start' });
        }
        function screenName(el) {
            return el.closest('[data-sq-screen]').dataset.sqScreen;
        }

        root.querySelector('[data-sq-start]').addEventListener('click', function () { goTo('q1'); });

        // Клик по опции: выбор + активный Next + автопереход через ~250мс
        root.querySelectorAll('[data-sq-options]').forEach(function (wrap) {
            wrap.addEventListener('click', function (e) {
                var btn = e.target.closest('.or-sq__opt');
                if (!btn) return;
                wrap.querySelectorAll('.or-sq__opt').forEach(function (o) { o.classList.remove('is-active'); });
                btn.classList.add('is-active');
                answers[wrap.dataset.sqKey] = btn.dataset.val;
                var next = wrap.closest('[data-sq-screen]').querySelector('[data-sq-next]');
                if (next) next.disabled = false;
                var from = screenName(wrap);
                clearTimeout(advTimer);
                advTimer = setTimeout(function () {
                    goTo(ORDER[ORDER.indexOf(from) + 1]);
                }, 250);
            });
        });

        root.querySelectorAll('[data-sq-back]').forEach(function (btn) {
            btn.addEventListener('click', function () {
                goTo(ORDER[ORDER.indexOf(screenName(btn)) - 1]);
            });
        });
        root.querySelectorAll('[data-sq-next]').forEach(function (btn) {
            btn.addEventListener('click', function () {
                if (btn.disabled) return;
                goTo(ORDER[ORDER.indexOf(screenName(btn)) + 1]);
            });
        });

        // --- email → Klaviyo ---
        var form = root.querySelector('[data-sq-form]');
        var nameInput = root.querySelector('[data-sq-name]');
        var emailInput = root.querySelector('[data-sq-email]');
        var consentCb = root.querySelector('[data-sq-consent]');
        var msgEl = root.querySelector('[data-sq-msg]');

        function planFromVisible() {
            var frost = FROST[state.zone];
            var packs = visible.map(function (c) { return cardData(c); });
            var reminders = [];
            packs.forEach(function (ds) {
                actionDates(state.zone, ds).forEach(function (a) {
                    reminders.push({ label: a.label, date: a.date, url: ds.url });
                });
            });
            reminders.sort(function (a, b) { return a.date - b.date; });
            return { packs: packs, reminders: reminders, lastFrost: frost ? frost[0] : 'none' };
        }

        form.addEventListener('submit', function (e) {
            e.preventDefault();
            var email = emailInput.value.trim();
            msgEl.hidden = true;
            if (!/.+@.+\..+/.test(email)) {
                msgEl.textContent = 'Please enter a valid email address.';
                msgEl.hidden = false;
                return;
            }
            if (!consentCb.checked) {
                msgEl.textContent = 'Please tick the consent box so we can email your plan.';
                msgEl.hidden = false;
                return;
            }

            // Сначала фильтруем (goTo → buildState + apply заполняет visible),
            // потом строим план по видимым карточкам — порядок важен
            goTo('results');
            var plan = planFromVisible();

            var klaviyo = window.klaviyo = window.klaviyo || [];
            var profile = {
                '$email': email,
                'USDA Zone': state.zone,
                'Garden Goals': state.goals.length ? state.goals : ['all'],
                'Gardener Level': state.beginner ? 'new' : 'experienced'
            };
            var firstName = nameInput.value.trim();
            if (firstName) profile['$first_name'] = firstName;
            if (plan.reminders.length) {
                profile['Next Start Date'] = isoDay(plan.reminders[0].date);
                profile['Planting Reminders'] = plan.reminders.map(function (r) {
                    return isoDay(r.date) + ' ' + r.label;
                });
            }
            klaviyo.push(['identify', profile]);

            // Подписка в список Klaviyo (double/single opt-in — по настройке списка).
            // Fire-and-forget: письмо с планом идёт по событию и не зависит от этого вызова
            var listId = root.dataset.klaviyoList;
            var companyId = root.dataset.klaviyoCompany;
            if (listId && companyId) {
                fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
                    body: JSON.stringify({
                        data: {
                            type: 'subscription',
                            attributes: {
                                custom_source: 'Seed Quiz',
                                profile: { data: { type: 'profile', attributes: { email: email } } }
                            },
                            relationships: { list: { data: { type: 'list', id: listId } } }
                        }
                    })
                }).catch(function () {});
            }
            klaviyo.push(['track', 'Requested Seed Plan', {
                usda_zone: state.zone,
                last_frost: plan.lastFrost,
                light: state.light,
                space: state.space,
                goals: state.goals,
                beginner: state.beginner,
                match_count: plan.packs.length,
                matched_packs: plan.packs.map(function (p) { return p.title; }),
                matched_pack_urls: plan.packs.map(function (p) { return location.origin + p.url; }),
                // Топ-4 для блока товаров в письме: visible уже отсортирован по скору.
                // В шаблоне Klaviyo: {% for item in event.top_matches %} item.title/url/image/price
                top_matches: visible.slice(0, 4).map(function (c) {
                    var ds = cardData(c);
                    var img = c.querySelector('.or-sf-card__img');
                    return {
                        title: ds.title,
                        url: location.origin + ds.url,
                        image: img && img.src ? img.src : '',
                        price: '$' + ds.price.toFixed(2)
                    };
                }),
                reminder_opt_in: true,
                reminders: plan.reminders.map(function (r) {
                    return { pack: r.label, date: isoDay(r.date) };
                }),
                quiz_answers: {
                    goal: answers.goal,
                    space: answers.space,
                    experience: answers.experience,
                    winters: answers.winters
                },
                source: 'quiz'
            }]);
        });

        root.querySelector('[data-sq-skip]').addEventListener('click', function () {
            goTo('results'); // без Klaviyo
        });

        // --- рестарт (кнопки в результатах и в пустой выдаче) ---
        root.querySelectorAll('[data-sq-restart]').forEach(function (btn) {
            btn.addEventListener('click', function () {
                answers = { goal: null, space: null, experience: null, winters: null };
                root.querySelectorAll('.or-sq__opt.is-active').forEach(function (o) { o.classList.remove('is-active'); });
                root.querySelectorAll('[data-sq-next]').forEach(function (b) { b.disabled = true; });
                msgEl.hidden = true;
                goTo('intro');
            });
        });
    }

    function initAll(scope) {
        (scope || document).querySelectorAll('[data-or-seed-quiz]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
        initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
